export const isNumberWithinRange = (inputNumber: number, min: number, max: number): boolean => {
    return inputNumber >= min && inputNumber <= max;
}